import React from 'react';
import { useHistory } from 'react-router-dom';

import Icon from '../atom/Icon';

export const BackButton = () => {
  const history = useHistory();
  return <Icon iconName="arrow_back" onClick={() => history.goBack()} />;
};
